import React from "react";
import { motion } from "framer-motion";
import "./AboutHero.scss";
import { ReactComponent as HeroBtnTag } from "../../assets/svg/heroBtnTag.svg";

const AboutHero = () => {
  return (
    <motion.section
      className="section aboutHero"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <article className="aboutHero__container container">
        <button type="button">
          <motion.span
            initial={{ y: 20, opacity: 0, scale: 1.1 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            About Us
          </motion.span>

          <motion.div
            initial={{ y: 20, opacity: 0, scale: 1.1 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <HeroBtnTag />
          </motion.div>
        </button>

        <motion.h2
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          Fueling Minds
        </motion.h2>

        <motion.h3
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          — Inspiring Designs...
        </motion.h3>
      </article>
    </motion.section>
  );
};

export default AboutHero;
